import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AffiliateProgram() {
  const [formData, setFormData] = useState({
    fullName: '',
    dateOfBirth: '',
    email: '',
    phone: '',
    country: '',
    city: '',
    preferredServices: [] as string[],
    facebook: '',
    instagram: '',
    tiktok: '',
    youtube: '',
    referralExperience: '',
    agreement: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [idDocument, setIdDocument] = useState<File | null>(null);

  const services = [
    'Visa Application Support',
    'Flight Ticket Booking',
    'Hotel Booking',
    'Tourism and Travel Packages',
    'Shipment and Logistics',
    'Trade and Business Services',
    'Web and App Development',
    'Photography and Videography',
    'Digital Marketing',
    'Reels and Content Creation'
  ];

  const countries = [
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
    'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
    'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
    'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
    'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
    'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
    'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
    'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
    'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan',
    'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar',
    'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia',
    'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal',
    'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan',
    'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar',
    'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia',
    'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa',
    'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan',
    'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan',
    'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City',
    'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
  ];

  const handleServiceToggle = (service: string) => {
    setFormData(prev => ({
      ...prev,
      preferredServices: prev.preferredServices.includes(service)
        ? prev.preferredServices.filter(s => s !== service)
        : [...prev.preferredServices, service]
    }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setIdDocument(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.agreement) {
      alert('Please agree to the terms and conditions');
      return;
    }

    if (formData.preferredServices.length === 0) {
      alert('Please select at least one service to promote');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSubmit = new URLSearchParams();
      formDataToSubmit.append('fullName', formData.fullName);
      formDataToSubmit.append('dateOfBirth', formData.dateOfBirth);
      formDataToSubmit.append('email', formData.email);
      formDataToSubmit.append('phone', formData.phone);
      formDataToSubmit.append('country', formData.country);
      formDataToSubmit.append('city', formData.city);
      formDataToSubmit.append('preferredServices', formData.preferredServices.join(', '));
      formDataToSubmit.append('facebook', formData.facebook);
      formDataToSubmit.append('instagram', formData.instagram);
      formDataToSubmit.append('tiktok', formData.tiktok);
      formDataToSubmit.append('youtube', formData.youtube);
      formDataToSubmit.append('referralExperience', formData.referralExperience);
      formDataToSubmit.append('idDocument', idDocument ? 'Uncollectable' : 'Not provided');

      const response = await fetch('https://readdy.ai/api/form/d4hqn5ttnoqs9bvm9t10', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSubmit.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          dateOfBirth: '',
          email: '',
          phone: '',
          country: '',
          city: '',
          preferredServices: [],
          facebook: '',
          instagram: '',
          tiktok: '',
          youtube: '',
          referralExperience: '',
          agreement: false
        });
        setIdDocument(null);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Join the <span className="text-yellow-400">Afriq Global</span> Affiliate Program
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
              Become a partner and earn commissions by promoting our premium digital solutions, travel services, and business offerings worldwide
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-lg">
              <div className="flex items-center">
                <i className="ri-check-line text-yellow-400 mr-2 w-6 h-6 flex items-center justify-center"></i>
                <span>Global Opportunities</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-yellow-400 mr-2 w-6 h-6 flex items-center justify-center"></i>
                <span>Competitive Commissions</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-yellow-400 mr-2 w-6 h-6 flex items-center justify-center"></i>
                <span>Full Support</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Services You Can Promote</h2>
            <p className="text-xl text-gray-600">Choose from our comprehensive range of premium services</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
                <div className="flex items-start">
                  <i className="ri-star-fill text-yellow-500 mr-3 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Registration Form */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Affiliate Registration</h2>
            <p className="text-xl text-gray-600">Fill out the form below to become an Afriq Global affiliate partner</p>
          </div>

          <form id="affiliate-form" onSubmit={handleSubmit} className="bg-gray-50 p-8 md:p-12 rounded-2xl shadow-lg" data-readdy-form>
            {/* Personal Information */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-user-line text-blue-700 mr-3 w-6 h-6 flex items-center justify-center"></i>
                Personal Information
              </h3>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Full Name *</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={(e) => setFormData({...formData, fullName: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Enter your full name"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Date of Birth *</label>
                  <input
                    type="date"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={(e) => setFormData({...formData, dateOfBirth: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="your.email@example.com"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Phone Number (with country code) *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="+971 50 123 4567"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Country *</label>
                  <select
                    name="country"
                    value={formData.country}
                    onChange={(e) => setFormData({...formData, country: e.target.value})}
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm cursor-pointer"
                  >
                    <option value="">Select your country</option>
                    {countries.map((country) => (
                      <option key={country} value={country}>{country}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">City *</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={(e) => setFormData({...formData, city: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Enter your city"
                  />
                </div>
              </div>
            </div>

            {/* Services Selection */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-service-line text-blue-700 mr-3 w-6 h-6 flex items-center justify-center"></i>
                Preferred Services to Promote *
              </h3>
              
              <div className="grid md:grid-cols-2 gap-4">
                {services.map((service, index) => (
                  <label key={index} className="flex items-center p-4 bg-white rounded-lg border-2 border-gray-200 hover:border-blue-500 cursor-pointer transition-all">
                    <input
                      type="checkbox"
                      checked={formData.preferredServices.includes(service)}
                      onChange={() => handleServiceToggle(service)}
                      className="w-5 h-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
                    />
                    <span className="ml-3 text-gray-700 font-medium">{service}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Social Media Profiles */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-share-line text-blue-700 mr-3 w-6 h-6 flex items-center justify-center"></i>
                Social Media Profiles
              </h3>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2 flex items-center">
                    <i className="ri-facebook-fill text-blue-600 mr-2 w-5 h-5 flex items-center justify-center"></i>
                    Facebook
                  </label>
                  <input
                    type="url"
                    name="facebook"
                    value={formData.facebook}
                    onChange={(e) => setFormData({...formData, facebook: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="https://facebook.com/yourprofile"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2 flex items-center">
                    <i className="ri-instagram-fill text-pink-600 mr-2 w-5 h-5 flex items-center justify-center"></i>
                    Instagram
                  </label>
                  <input
                    type="url"
                    name="instagram"
                    value={formData.instagram}
                    onChange={(e) => setFormData({...formData, instagram: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="https://instagram.com/yourprofile"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2 flex items-center">
                    <i className="ri-tiktok-fill text-gray-900 mr-2 w-5 h-5 flex items-center justify-center"></i>
                    TikTok
                  </label>
                  <input
                    type="url"
                    name="tiktok"
                    value={formData.tiktok}
                    onChange={(e) => setFormData({...formData, tiktok: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="https://tiktok.com/@yourprofile"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2 flex items-center">
                    <i className="ri-youtube-fill text-red-600 mr-2 w-5 h-5 flex items-center justify-center"></i>
                    YouTube
                  </label>
                  <input
                    type="url"
                    name="youtube"
                    value={formData.youtube}
                    onChange={(e) => setFormData({...formData, youtube: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="https://youtube.com/@yourprofile"
                  />
                </div>
              </div>
            </div>

            {/* Document Upload */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-file-line text-blue-700 mr-3 w-6 h-6 flex items-center justify-center"></i>
                Identity Verification
              </h3>
              
              <div>
                <label className="block text-gray-700 font-semibold mb-2">National ID or Passport *</label>
                <div className="relative">
                  <input
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf,.jpg,.jpeg,.png"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm cursor-pointer"
                  />
                  <p className="text-sm text-gray-500 mt-2">Accepted formats: PDF, JPG, PNG (Max 5MB)</p>
                  {idDocument && (
                    <p className="text-sm text-green-600 mt-2 flex items-center">
                      <i className="ri-check-line mr-1 w-4 h-4 flex items-center justify-center"></i>
                      File selected: {idDocument.name}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Referral Experience */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-chat-3-line text-blue-700 mr-3 w-6 h-6 flex items-center justify-center"></i>
                Referral Experience (Optional)
              </h3>
              
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Tell us about your experience</label>
                <textarea
                  name="referralExperience"
                  value={formData.referralExperience}
                  onChange={(e) => {
                    if (e.target.value.length <= 500) {
                      setFormData({...formData, referralExperience: e.target.value});
                    }
                  }}
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="Share your experience with affiliate marketing, referrals, or promoting services..."
                ></textarea>
                <p className="text-sm text-gray-500 mt-2 text-right">{formData.referralExperience.length}/500 characters</p>
              </div>
            </div>

            {/* Agreement */}
            <div className="mb-8">
              <label className="flex items-start p-4 bg-blue-50 rounded-lg border-2 border-blue-200 cursor-pointer">
                <input
                  type="checkbox"
                  checked={formData.agreement}
                  onChange={(e) => setFormData({...formData, agreement: e.target.checked})}
                  required
                  className="w-5 h-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-500 mt-1 cursor-pointer"
                />
                <span className="ml-3 text-gray-700">
                  <strong>I agree to the terms and conditions of the Afriq Global Affiliate Program *</strong>
                  <br />
                  <span className="text-sm text-gray-600">By checking this box, you confirm that all information provided is accurate and you agree to comply with our affiliate program policies.</span>
                </span>
              </label>
            </div>

            {/* Submit Status Messages */}
            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-green-50 border-2 border-green-500 rounded-lg">
                <div className="flex items-center text-green-800">
                  <i className="ri-check-circle-fill text-2xl mr-3 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <strong className="block">Application Submitted Successfully!</strong>
                    <span className="text-sm">Thank you for applying. We'll review your application and contact you via email within 2-3 business days.</span>
                  </div>
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mb-6 p-4 bg-red-50 border-2 border-red-500 rounded-lg">
                <div className="flex items-center text-red-800">
                  <i className="ri-error-warning-fill text-2xl mr-3 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <strong className="block">Submission Failed</strong>
                    <span className="text-sm">There was an error submitting your application. Please try again or contact us directly.</span>
                  </div>
                </div>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full py-4 bg-gradient-to-r from-blue-700 to-blue-900 hover:from-blue-800 hover:to-blue-950 text-white font-bold text-lg rounded-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? (
                <span className="flex items-center justify-center">
                  <i className="ri-loader-4-line animate-spin mr-2 w-5 h-5 flex items-center justify-center"></i>
                  Submitting...
                </span>
              ) : (
                <span className="flex items-center justify-center">
                  <i className="ri-send-plane-fill mr-2 w-5 h-5 flex items-center justify-center"></i>
                  Become an Affiliate
                </span>
              )}
            </button>
          </form>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why Join Our Affiliate Program?</h2>
            <p className="text-xl text-gray-600">Unlock exclusive benefits and grow your income</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-money-dollar-circle-fill text-blue-700 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Competitive Commissions</h3>
              <p className="text-gray-600 leading-relaxed">Earn attractive commissions on every successful referral with transparent tracking and timely payouts</p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md text-center">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-global-line text-yellow-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Global Reach</h3>
              <p className="text-gray-600 leading-relaxed">Promote our services to clients worldwide and expand your earning potential across multiple markets</p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-2-fill text-green-700 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Dedicated Support</h3>
              <p className="text-gray-600 leading-relaxed">Get full support from our team with marketing materials, training, and ongoing assistance</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 lg:py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 lg:mb-6">Have Questions?</h2>
          <p className="text-lg md:text-xl mb-6 lg:mb-8 leading-relaxed">
            Our team is here to help you understand the program and get started
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4">
            <a 
              href="tel:+971545475624"
              className="px-6 lg:px-8 py-3 lg:py-4 bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center justify-center text-sm lg:text-base"
            >
              <i className="ri-phone-fill mr-2 w-5 h-5 flex items-center justify-center"></i>
              Call Us: +971 545475624
            </a>
            <a 
              href="https://wa.me/971545475624"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 lg:px-8 py-3 lg:py-4 bg-green-500 hover:bg-green-600 text-white font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center justify-center text-sm lg:text-base"
            >
              <i className="ri-whatsapp-fill mr-2 w-5 h-5 flex items-center justify-center"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
